import { Avatar, Box, Divider, Stack, Typography } from '@mui/material';
import { useImposter, useIsDesktop } from 'Hooks';
import {
  Approvals,
  Compass,
  Contact,
  Details,
  Equipment,
  Medicine,
  Payments,
  Referrals,
  Status,
  Treatments,
  Updates,
} from 'Images/ActivitiesLobby';
import { ActivityItem } from './ActivityItem';
import {
  IActivityCategory,
  getActivities,
} from 'API/ActivitiesLobby/activitiesLobby';
import { useEffect, useState } from 'react';

const activityIdToIcon: { [id: number]: string } = {
  1: Payments,
  2: Referrals,
  3: Contact,
  4: Treatments,
  5: Compass,
  6: Medicine,
  7: Equipment,
  8: Status,
  9: Approvals,
  10: Details,
  11: Updates,
};

const universalRequestId = 12;

export const Activities = () => {
  const isDesktop = useIsDesktop();

  const [activitiesList, setActivitiesList] = useState<IActivityCategory[]>([]);

  const initActivities = async () => {
    const activities = await getActivities();

    if (activities)
      setActivitiesList(
        activities.filter((activity) => activity.id !== universalRequestId)
      );
  };

  const { fakeUser } = useImposter();

  useEffect(() => {
    initActivities();
  }, [fakeUser]);

  return (
    <Stack
      gap={'24px'}
      m={'40px 0 80px 0'}
      width={isDesktop ? undefined : '100%'}
    >
      {activitiesList.map((activity, index) => (
        <Box key={activity.title}>
          <Stack
            component={'fieldset'}
            sx={
              isDesktop
                ? {
                    width: '802px',
                    p: '24px',
                    bgcolor: 'white',
                    border: '1px solid',
                    borderRadius: '16px',
                    borderColor: 'purple2.shade_100',
                    gap: '16px',
                  }
                : { width: '100%', gap: '12px' }
            }
          >
            <legend>{activity.title}</legend>
            <Stack
              flexDirection={'row'}
              gap={isDesktop ? '10px' : '8px'}
              alignItems={'center'}
            >
              <Avatar
                alt=''
                src={activityIdToIcon[activity.id]}
                sx={isDesktop ? undefined : { width: '28px', height: '28px' }}
              />
              <Typography component={'h2'}>{activity.title}</Typography>
            </Stack>
            <Stack
              columnGap={'12px'}
              rowGap={'16px'}
              flexDirection={'row'}
              width={'100%'}
              flexWrap={'wrap'}
            >
              {activity.activities.map((subActivity) => (
                <ActivityItem key={subActivity.id} activity={subActivity} />
              ))}
            </Stack>
          </Stack>
          {!isDesktop && index < activitiesList.length - 1 && (
            <Divider
              sx={{ borderColor: 'primary.shade_100', mt: '24px' }}
              aria-hidden={true}
              flexItem
            />
          )}
        </Box>
      ))}
    </Stack>
  );
};
